import React, { useContext } from 'react'
import GeoContext from 'contexts/geoContext'
import PartnershipLabel from 'components/Luxkit/Label/PartnershipLabel'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'

function isInvalid<T>(types: Array<T>, target: T): boolean {
  return types.length > 0 && !types.includes(target)
}

interface Props {
  className?: string;
  offer: App.Offer | App.OfferSummary;
  price: number;
}

function OfferPackagePartnershipLabel(props: Props) {
  const {
    offer,
    className,
    price,
  } = props

  const { partnership } = useContext(GeoContext)

  if (!partnership ||
    (partnership.availableForOfferType && isInvalid(partnership.availableForOfferType, offer.type)) ||
    (partnership.availableForProductType && isInvalid(partnership.availableForProductType, offer.productType))
  ) {
    return null
  }
  const formattedPrice = parseFloat((partnership.rewardConversion * price).toFixed(2))
  return (
    <LabelGroup>
      <PartnershipLabel
        className={className}
        points={formattedPrice}
      />
    </LabelGroup>
  )
}

export default React.memo(OfferPackagePartnershipLabel)
